import { useDispatch } from 'react-redux';

import { Accordion, Divider, VStack } from '@frontend/components';

import { useAppSelector } from 'store/hooks';

import { setExpandedCustomerInfoStepIndices } from '../data/actions';
import { getExpandedCustomerInfoStepIndices } from '../data/reducer';
import { BillTo } from './BillTo';
import { PaymentMethod } from './PaymentMethod';
import { ShipToFacility } from './ShipToFacility';
import { ShippingOptions } from './ShippingOptions';

const CustomerInformation = () => {
  const dispatch = useDispatch();
  const accordionIndices = useAppSelector(getExpandedCustomerInfoStepIndices);

  return (
    <VStack spacing={2}>
      <PaymentMethod />
      <Divider />
      <Accordion
        width="100%"
        allowMultiple={true}
        allowToggle={true}
        index={accordionIndices}
        onChange={(expandedIndices) =>
          dispatch(
            setExpandedCustomerInfoStepIndices({
              expandedCustomerInfoStepIndices: expandedIndices,
            }),
          )
        }
      >
        <ShipToFacility />
        <BillTo />
        <ShippingOptions />
      </Accordion>
    </VStack>
  );
};

export default CustomerInformation;
